var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zone"},[_c('TJDetailTitle',{attrs:{"titleData":'基本信息'}}),_c('TJDetailMenu',{attrs:{"dataList":_vm.dataList}}),_c('TJDetailTitle',{attrs:{"titleData":'样本检测详情'}}),_c('TJDetailMenu',{attrs:{"dataList":_vm.dataList2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }